import { AuthPage } from '@pages/auth';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta('Авторизация', 'Вход в панель управления');
}

export default function Page() {
  return <AuthPage />;
}
